export default "__VITE_PUBLIC_ASSET__4690533a__"